import React from "react";
import {
    Container,
    Header,
    Grid,
    Image,
    Divider
} from "semantic-ui-react";
import Contact from "./components/Contact";
import Publications from "./components/Publications";
import Links from "./components/Links";
import Footer from "./components/Footer";
import photo from "./assets/photo.jpg";

const App = () => (
    <Container text style={{ marginTop: "5em", marginBottom: "2em" }}>
        <Grid stackable style={{ marginBottom: "2em" }}>
            <Grid.Column width={12}>
                <Grid stackable>
                    <Grid.Row >
                        <Grid.Column width={4}>
                            <Image src={photo} size="small" />
                        </Grid.Column>
                        <Grid.Column width={12}>
                            <Header as="h1">
                                <Header.Content>
                                    Jonatan Hamberg
                                    <Divider />
                                    <Header.Subheader>
                                        Jonatan Hamberg is a Computer Scientist, Developer and a MSc student at the <a href="https://cs.helsinki.fi">University of Helsinki, Finland</a>.
                                        His research interests and topics include <b>Crowdsensing</b>, <b>IoT</b> and <b>Big Data Architectures</b>.
                                    </Header.Subheader>
                                </Header.Content>
                            </Header>
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                        <Grid.Column width={16}>
                            <p>
                                I work in the <a href="https://www.cs.helsinki.fi/en/nodes">NODES group</a> at the Department of Computer Science, University of Helsinki, where I participate in various projects, such as <a href="http://carat.cs.helsinki.fi/">Carat</a>, <a href="https://ubispark.cs.helsinki.fi/">UbiSpark</a> and <a href="https://www.helsinki.fi/en/researchgroups/sensing-and-analytics-of-air-quality/about-megasense">MegaSense</a>.
                                In addition, I am also involved in a collaboration with the RIB-consortium and research related to mobile thermal imaging.</p>
                            <p>
                                My activities include scientific writing, full-stack programming, cloud deployment (AWS), DevOps, data preprocessing (Unix) and a bit of statistical analysis and visualization.
                                I am interested in programming, strategic and logistic games, <a href="https://www.youtube.com/watch?v=6Stu7h7Qup8">music</a> and economics. I strive to make a positive difference in the world.
                            </p>
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                        <Grid.Column width={16}>
                            <Header as="h3">Publications</Header>
                            <div>
                                <Publications authorId={51217525} />
                            </div>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </Grid.Column>
            <Grid.Column width={4} style={{ fontSize: 12, color: "gray" }}>
                <Contact />
                <Links />
            </Grid.Column>
        </Grid>
        <Divider/>
        <Footer />
    </Container>
);

export default App;